import React from 'react';
import { Box, Typography } from '@mui/material';
import { FormikValues, useFormikContext } from 'formik';
import { EventTitle, EventIcon, EventBox } from './ParentEventSelector.styles';
import { useEventTitle } from '../../i18n/useEventTitle';

interface ParentEventSelectorProps {
  events: {
    title: string;
    icon: string;
  }[];
}

const STORAGE = process.env.REACT_APP_STORAGE as string;

const ParentEventSelector: React.FC<ParentEventSelectorProps> = ({ events }) => {
  const eventTitle = useEventTitle();
  const { values, errors, touched, setFieldValue } = useFormikContext<FormikValues>();

  const toggleEvent = (title: string) => {
    const isAlreadySelected = values.selectedEvents.includes(title);
    const updated = isAlreadySelected ? values.selectedEvents.filter((t: string) => t !== title) : [...values.selectedEvents, title];
    if (isAlreadySelected) {
      const newConfigs = { ...(values.eventConfigs || {}) };
      delete newConfigs[title];
      setFieldValue('eventConfigs', newConfigs);
    }
    setFieldValue('selectedEvents', updated);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        {events.map(event => {
          const isSelected = values.selectedEvents.includes(event.title);
          return (
            <EventBox key={event.title} selected={isSelected} onClick={() => toggleEvent(event.title)}>
              <EventIcon src={`${STORAGE}${event.icon}`} alt={eventTitle(event.title)} selected={isSelected} />
              <EventTitle variant="body2" selected={isSelected}>
                {eventTitle(event.title)}
              </EventTitle>
            </EventBox>
          );
        })}
      </Box>
      {touched.selectedEvents && errors.selectedEvents && (
        <Typography color="error" sx={{ mt: 1 }}>
          {errors.selectedEvents as string}
        </Typography>
      )}
    </Box>
  );
};

export default ParentEventSelector;
